import { ChatId } from 'src/app/store/samwin/chats/models/chat-id';
import { CommandWithPayload } from './command';
import { ChatMessageSender } from './chat-message-sender';

export class ProcessNewMessageCommand extends CommandWithPayload<ProcessNewMessageCommandPayload> {
   public static readonly commandType: string = 'samwin/process-new-message';

   public constructor(public chatId: ChatId, public payload: ProcessNewMessageCommandPayload) {
      super(ProcessNewMessageCommand.commandType, chatId, payload);
   }
}

export class ProcessNewMessageCommandPayload {
   public constructor(public text: string, public timestamp: Date, public sender: ChatMessageSender) {
      // nothing to do
   }
}
